import { Component, Prop, Vue } from "vue-property-decorator";

import { CreateElement } from "vue";
import Card from "@/components/Card.tsx";
import NotificationBar from "@/components/Notification";
import { Module, TTMJ } from "@/store/enums";
import { fetchAllItems } from "./StorageHandler";
import firebase from "firebase/app";
import { db, userDataCollection } from "@/firebase.ts";
import { taskCompleted } from "./utils";

enum PATTERN_REASONING_STATE {
  DESCRIPTION,
  PATTERN
}

@Component
export default class TalkToMeJrPatternReasoning extends Vue {
  patternList: any = [];
  private frames: PATTERN_REASONING_STATE = PATTERN_REASONING_STATE.DESCRIPTION;
  // integers between 1 to 6
  selections: any[] = Array(this.patternList.length);
  currentPattern = 0;
  private audioLoc =
    "/res/protected/t2mejr_instructions/ttmj_pattern_autoplay.mp3";
  private _enableNext!: boolean;

  async created() {
    this.frames = PATTERN_REASONING_STATE.DESCRIPTION;
    this._enableNext = false;
    this.$store.dispatch("setClip", {
      path: this.audioLoc,
      callbackFunction: () => {
        this._enableNext = true;
        this.$forceUpdate();
      }
    });
    this.$forceUpdate();

    this.$forceUpdate();
    await this._getData();
  }

  beforeDestroy() {
    this.$store.dispatch("removeClip", this.audioLoc);
  }

  private async _getData() {
    for (let j = 1; j < 11; j++) {
      let data: any = await fetchAllItems(
        `res/protected/pattern_reasoning/puzzle${j}`
      );
      let pattern: any = {};
      let choices: any[] = [];
      data.map((i: { url: string; name: string }, idx: any) =>
        i.name.includes("top")
          ? (pattern = { imgLink: i.url, name: 7 })
          : choices.push({
              imgLink: i.url,
              value: this.patternLabel(i.name)
            })
      );
      choices.sort((a, b) => {
        return a.value.charCodeAt(0) - b.value.charCodeAt(0);
      });
      this.patternList.push({ pattern: pattern, choices: choices });
    }
  }

  private patternLabel(name: string) {
    // returns alphabet corresponding to how it's labelled in the image
    return name[name.indexOf("_") + 1];
  }

  private _description() {
    return (
      <Card title="I can solve puzzles." mod={Module.TTMJ}>
        <div slot="mainContent">
          Here are some puzzles. Solve each one by choosing the best match for
          the pattern. Are you ready? Click “Next” to begin.
        </div>
        <div slot="actions">
          <v-btn
            color="warning"
            onClick={(e: any) => {
              this.frames = PATTERN_REASONING_STATE.PATTERN;
              this.$forceUpdate();
            }}
            disabled={!this._enableNext}
          >
            Next
          </v-btn>
        </div>
      </Card>
    );
  }

  render(h: CreateElement) {
    return this.frames === PATTERN_REASONING_STATE.DESCRIPTION ? (
      this._description()
    ) : (
      <Card title="Solve the puzzles." mod={Module.TTMJ}>
        <div slot="mainContent">
          <p>
            Look at the shapes below. Click on the shape that fits in the empty
            box.
          </p>
          {this._main(this.currentPattern)}
        </div>
        <div slot="actions">
          <v-btn onClick={this._back} disabled={this.currentPattern < 1}>
            Back
          </v-btn>
          <v-btn
            onClick={this._next}
            disabled={!this.selections[this.currentPattern]}
          >
            Next
          </v-btn>
        </div>
      </Card>
    );
  }

  private _back() {
    if (this.currentPattern > 0) {
      this.currentPattern -= 1;
    }
  }

  private _next() {
    if (this.currentPattern < this.patternList.length - 1) {
      this.currentPattern += 1;
    } else {
      this.writeToDatabase(this.selections);
      this.$router.push({
        name: "t2mejr-tasklist"
      });
    }
  }

  private writeToDatabase(selections: number[]) {
    let currUser = firebase.auth().currentUser;
    if (!currUser) {
      // alert("User doesn't exist.");
      return;
    }
    db.collection("userData")
      .doc(currUser.uid)
      .collection("ttmj")
      .doc("responses")
      .collection("patternReasoning")
      .doc("Responses")
      .set({
        choices: selections
      })
      .then(
        success => {
          if (!currUser) return;
          taskCompleted(currUser.uid, TTMJ.PATREASON);
        },
        failure => {
          // alert("Failure to write to the database: " + failure);
        }
      );
  }

  private _main(patternNumber: number) {
    let imageStyle = {
      margin: "0 3px",
      cursor: "pointer",
      borderRadius: "10px"
    };

    let radioStyle = {
      position: "absolute",
      opacity: 0,
      width: 0,
      height: 0
    };

    let selectedStyle: any = {
      outline: "2px solid #f00"
    };

    let alphabets = ["A", "B", "C", "D", "E", "F"];

    return (
      <v-container>
        <v-row justify="end">
          <label>
            Pattern {`${this.currentPattern + 1}/${this.patternList.length}`}
          </label>
        </v-row>
        <v-row
          style={{
            minHeight: "120px",
            outline: "1px solid lightgrey"
          }}
          justify="center"
          align-content="center"
        >
          <v-img
            src={
              this.patternList[patternNumber]
                ? this.patternList[patternNumber].pattern.imgLink
                : ""
            }
            style={imageStyle}
          ></v-img>
        </v-row>
        <v-row
          style={{
            minHeight: "150px",
            backgroundColor: "#E2E1E0",
            marginTop: "10px"
          }}
          justify="center"
          align-content="center"
        >
          {this.patternList[patternNumber] &&
            this.patternList[patternNumber].choices.map((x: any, i: any) => (
              <label style={{ textAlign: "center" }}>
                <input
                  type="radio"
                  name={i}
                  value={x.value}
                  style={radioStyle}
                  onClick={() => {
                    this.selections[patternNumber] = {
                      choice: x.value,
                      imageLink: x.imgLink
                    };
                    this.$forceUpdate();
                  }}
                />
                <v-img
                  src={x.imgLink}
                  max-width="90px"
                  height="90px"
                  style={{
                    ...imageStyle,
                    ...(this.selections[patternNumber] &&
                    this.selections[patternNumber].choice == x.value
                      ? selectedStyle
                      : {})
                  }}
                ></v-img>
                <label>
                  <b>{alphabets[i]}</b>
                </label>
              </label>
            ))}
        </v-row>
      </v-container>
    );
  }
}
